export const definePinoWebTransport = (onLog, buildFunction) => options => {
  buildFunction?.(options);
  return onLog;
};
//# sourceMappingURL=definePinoWebTransport.js.map